module.exports = __webpack_public_path__ + "static/media/footer-post-signup-twitter.7295696e.svg";